export default __webpack_public_path__ + "static/media/a9.c78da969.jpg";